export {
  TrayPredictionEntity,
  type TrayPredictionItem,
} from './tray-prediction.entity';
export { OemTrayRepository, oemTrayRepository } from './repository';
export {
  oemTrayKeys,
  useOemTrayPrediction,
  type OemTrayPredictionVariables,
} from './hooks';
